import hljs from 'highlight.js/lib/core';
import javascript from 'highlight.js/lib/languages/javascript';
import bash from 'highlight.js/lib/languages/bash';
import json from 'highlight.js/lib/languages/json';
import http from 'highlight.js/lib/languages/http';
import 'highlight.js/styles/atom-one-dark.css';

hljs.registerLanguage('javascript', javascript);
hljs.registerLanguage('bash', bash);
hljs.registerLanguage('json', json);
hljs.registerLanguage('http', http);

const copy = () => {
  const copyButtons = document.querySelectorAll('.icon-button');

  copyButtons.forEach(button => {
    button.addEventListener('click', function() {
      // Get the section ID from data attribute
      const sectionId = this.getAttribute('data-section');
      // Construct the full URL
      const url = `${window.location.href.split('#')[0]}${sectionId ? `#${sectionId}` : ''}`;

      // Copy to clipboard
      navigator.clipboard.writeText(url)
        .then(() => {
          // Optional: Add visual feedback
          console.log('URL copied'); // You can replace this with a tooltip or notification
        })
        .catch(err => {
          console.error('Failed to copy URL:', err);
        });
    });
  });
}

const main = () => {
  hljs.highlightAll();
  copy();
}

document.addEventListener("DOMContentLoaded", () => {
  main();
});
